module.exports = __webpack_public_path__ + "img/stoverload-14.7e51404b.jpeg";